export default "__VITE_ASSET__cbfecb16__"